import { render, staticRenderFns } from "./CreatorItem.vue?vue&type=template&id=8f3ddfb8&scoped=true&"
import script from "./CreatorItem.vue?vue&type=script&lang=ts&"
export * from "./CreatorItem.vue?vue&type=script&lang=ts&"
import style0 from "./CreatorItem.vue?vue&type=style&index=0&id=8f3ddfb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3ddfb8",
  null
  
)

export default component.exports